'use strict';
import * as $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024$0024anon$00241 from "./com.raquo.laminar.codecs.package$$anon$1.js";
import * as $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024$0024anon$00242 from "./com.raquo.laminar.codecs.package$$anon$2.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_codecs_package$() {
  this.ci = null;
  this.GK = null;
  this.yZ = null;
  this.gN = null;
  $n_Lcom_raquo_laminar_codecs_package$ = this;
  this.ci = new $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024$0024anon$00242.$c_Lcom_raquo_laminar_codecs_package$$anon$2($m_Lcom_raquo_laminar_codecs_package$());
  this.GK = new $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024$0024anon$00242.$c_Lcom_raquo_laminar_codecs_package$$anon$2($m_Lcom_raquo_laminar_codecs_package$());
  this.yZ = new $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024$0024anon$00242.$c_Lcom_raquo_laminar_codecs_package$$anon$2($m_Lcom_raquo_laminar_codecs_package$());
  this.gN = new $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024$0024anon$00241.$c_Lcom_raquo_laminar_codecs_package$$anon$1();
}
export { $c_Lcom_raquo_laminar_codecs_package$ as $c_Lcom_raquo_laminar_codecs_package$ };
$p = $c_Lcom_raquo_laminar_codecs_package$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_codecs_package$;
/** @constructor */
function $h_Lcom_raquo_laminar_codecs_package$() {
}
export { $h_Lcom_raquo_laminar_codecs_package$ as $h_Lcom_raquo_laminar_codecs_package$ };
$h_Lcom_raquo_laminar_codecs_package$.prototype = $p;
var $d_Lcom_raquo_laminar_codecs_package$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_codecs_package$, "com.raquo.laminar.codecs.package$", ({
  hG: 1
}));
export { $d_Lcom_raquo_laminar_codecs_package$ as $d_Lcom_raquo_laminar_codecs_package$ };
var $n_Lcom_raquo_laminar_codecs_package$;
function $m_Lcom_raquo_laminar_codecs_package$() {
  if ((!$n_Lcom_raquo_laminar_codecs_package$)) {
    $n_Lcom_raquo_laminar_codecs_package$ = new $c_Lcom_raquo_laminar_codecs_package$();
  }
  return $n_Lcom_raquo_laminar_codecs_package$;
}
export { $m_Lcom_raquo_laminar_codecs_package$ as $m_Lcom_raquo_laminar_codecs_package$ };
